// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"yHDFR","input":"lql4a","unset":"qp7ak","generateButton":"GgNT5","rightSection":"nSEyT"};